var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 2.74999H16.4163V1.83332C16.4163 1.32916 16.0038 0.916656 15.4997 0.916656C14.9955 0.916656 14.583 1.32916 14.583 1.83332V2.74999H5.41634V1.83332C5.41634 1.32916 5.00384 0.916656 4.49967 0.916656C3.99551 0.916656 3.58301 1.32916 3.58301 1.83332V2.74999H2.66634C1.65801 2.74999 0.833008 3.57499 0.833008 4.58332V19.25C0.833008 20.2583 1.65801 21.0833 2.66634 21.0833H17.333C18.3413 21.0833 19.1663 20.2583 19.1663 19.25V4.58332C19.1663 3.57499 18.3413 2.74999 17.333 2.74999ZM16.4163 19.25H3.58301C3.07884 19.25 2.66634 18.8375 2.66634 18.3333V7.33332H17.333V18.3333C17.333 18.8375 16.9205 19.25 16.4163 19.25Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCalendarIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCalendarIcon.5ca84c8e4440a464b2ee395b0fad5586.svg";
export { ForwardRef as ReactComponent };